var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-preview-contents min-h-screen"},[_c('iframe',{ref:"iframe",staticClass:"min-h-screen",attrs:{"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }